<template>
  <div id="item-info">
    <ul
      class="_list"
      style="margin: 0; padding: 0; list-style: none"
      v-if="info != null"
    >
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('components.itemInfo.lastUser')"
        placement="right"
      >
        <li v-if="info.owner != null && info.owner != ''">
          <div
            style="display: flex; flex-direction: row; align-items: center; padding: 3px 5px; border-radius: 15px; border: 1px solid #ddd; padding-right: 10px; margin-bottom: 10px"
          >
            <el-avatar
              :size="'small'"
              style="width: 20px; height: 20px"
              :src="info.owner.image"
            ></el-avatar>
            <span style="margin-left:10px; display: inline-block">
              {{ info.owner.firstName }} {{ info.owner.lastName }}
            </span>
          </div>
        </li>
      </el-tooltip>
      <li v-if="data != null && data != ''">
        <strong>ID: </strong>{{ data.id }}
        <el-tooltip
          v-if="info.ipAddress != null"
          class="item"
          effect="dark"
          :content="info.ipAddress"
          placement="right"
        >
          <i class="icon-earth" style="font-size: 14px; margin-left: 5px"></i>
        </el-tooltip>
      </li>
      <li v-if="data.createDate != null && data.createDate != ''">
        <strong>{{$t('components.itemInfo.creation')}} </strong
        >{{ $moment(data.createDate).format("DD MMMM YYYY, dddd - HH:mm") }}
      </li>
      <li
        v-if="data.updateDate != null && data.updateDate != ''"
        style="margin-bottom: 15px"
      >
        <strong>{{$t('components.itemInfo.update')}} </strong
        >{{ $moment(data.updateDate).format("DD MMMM YYYY, dddd - HH:mm") }}
      </li>
    </ul>
    <div
      style="display: block; margin-bottom: 10px; padding-bottom: 10px; text-align: center"
      v-if="nodata"
    >
      {{$t('no_data')}}
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  name: "ItemInfo",
  props: ["data"],
  data() {
    return {
      moment,
      info: null,
      nodata: false,
    };
  },
  methods: {
    getData() {
      axios
        .post("general/getlatestactivity", { id: this.data.id })
        .then((res) => {
          if (res.data.data == null || res.data.data.item == null) {
            this.nodata = true;
          } else {
            this.info = res.data.data.item;
            this.nodata = false;
          }
        });
    },
  },
  mounted() {
    if (this.data.id != null && this.data.id != "") {
      this.getData();
    } else {
      this.info = null;
    }
  },
  watch: {
    data: {
      handler: function(newVal) {
        if (this.data.id != null && this.data.id != "") {
          this.getData();
        } else {
          this.info = null;
        }
      },
      deep: true,
    },
  },
};
</script>
<style>
._list {
  margin: 0px;
  padding: 0px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemInfo.vue